import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
// import { LocalStorageService } from "../services/LocalStorageService";
import Cookies from 'universal-cookie';

let isRefreshing = false;
let failedQueue: Array<any> = [];

export abstract class Axios {

    protected instance: AxiosInstance;
    protected token: string = '';
    protected readonly baseURL: string;

    public constructor() {
        
        this.baseURL = `${process.env.REACT_APP_API_URL}`
        this.instance = axios.create({
            baseURL: `${this.baseURL}/api/v1/`,
            timeout: 50000,
            responseType: "json",
            headers: {
                'Accept-Version': 1,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                // "Origin": "http://localhost:8101"
            }
        });

        this.initializeRequestInterceptor();
        this.initializeResponseInterceptor();
        // Instantiate the interceptor

    }

    private initializeRequestInterceptor = () => {
        this.instance.interceptors.request.use(this.handleRequest);
    };


    private initializeResponseInterceptor = () => {
        this.instance.interceptors.response.use((response: AxiosResponse) => {
            return response?.data;
        }, this.handleError);

        // axios.interceptors.response.use(function (response) {
        //     throw new axios.Cancel('Operation canceled by the user.');
        //   }, function (error) {
        //     return Promise.reject(error);
        // });

    }

    private handleRequest = async (config: AxiosRequestConfig | any) => {
        if(this.token){
            config.headers['Authorization'] = `Bearer ${this.token}`;
        }
        const cookies = new Cookies(null, { path: '/' });
        const jwtToken = cookies.get('ACCESS_TOKEN')
        const jwtTokenType = cookies.get('TOKEN_TYPE')
        if (jwtToken) {
            config.headers.Authorization = `${jwtTokenType} ${jwtToken}`;
        }
        return config;
    };


    private processQueue = (error: any, token: string | null = null) => {
        failedQueue.forEach(prom => {
            if (error) {
                prom.reject(error);
            } else {
                prom.resolve(token);
            }
        })
        failedQueue = [];
    }

    private handleError = async (error: AxiosError) => {

        const cookies = new Cookies(null, { path: '/' });
        const errorData = error.response?.data as any;
        const originalRequest = error?.config as any;
        const statusCode = error?.response?.status
        const errorMessage = errorData?.errors?.join('')


        if (statusCode === 401 && !originalRequest?._retry) {


            // if (isRefreshing) {
            //     return new Promise(function (resolve, reject) {
            //         failedQueue.push({ resolve, reject })
            //     }).then(token => {
            //         originalRequest.headers['Authorization'] = 'Bearer ' + token;
            //         return axios(originalRequest);
            //     }).catch(err => {
            //         return Promise.reject(err);
            //     })
            // }


            originalRequest._retry = true;
            isRefreshing = true;

            return new Promise(async (resolve, reject) => {
                cookies.remove('ACCESS_TOKEN');
                resolve(axios(originalRequest));
                window.location.href= "/login"
            })

        }

        return error?.response
    }

}

